const CLASSES = {
	active: 'is-active',
	hovered: 'is-hovered',
	menuOpen: 'is-menu-open',
	blocked: 'is-blocked',
	topNav: 'is-top-nav',
	childOpen: 'is-child-open',
};

const DESKTOP_WIDTH = 1280;
let scrollTop = 0;

const isDesktop = () => window.innerWidth >= DESKTOP_WIDTH;

const createSubNav = (subNavEl, headerEl, openMenu, closeMenu, menuBgEl) => {
	const parentEl = subNavEl.closest('.js-nav-parent');
	const parentNavEl = subNavEl.parentElement.closest('.js-nav-sublist') || subNavEl.closest('.js-menu');
	const subNavs = Array.from(headerEl.querySelectorAll('.js-nav-parent'));
	const backBtn = subNavEl.querySelector('.js-nav-back');
	const parentElements = [];
	let currentElement = subNavEl.parentElement;

	while (currentElement) {
		if (currentElement.classList.contains('js-nav-parent')) {
			parentElements.push(currentElement);
		}
		currentElement = currentElement.parentElement;
	}
	parentEl.addEventListener('click', (e) => {
		e.stopPropagation();
		if (parentEl.classList.contains(CLASSES.active) && parentEl.classList.contains(CLASSES.topNav)) {
			closeMenu();
			return;
		}
		const subNavsWithoutCurrent = subNavs.filter(element => !parentElements.includes(element));
		subNavsWithoutCurrent.forEach(item => {
			item.classList.remove(CLASSES.active);
			item.querySelectorAll('.js-nav-sublist').forEach(sublist => {
				sublist.classList.remove(CLASSES.active);
			});
			item.querySelectorAll('.js-nav-parent').forEach(sublistParent => {
				sublistParent.classList.remove(CLASSES.active);
			});
		});
		parentEl.classList.add(CLASSES.active);
		subNavEl.classList.add(CLASSES.active);
		if (!headerEl.classList.contains(CLASSES.menuOpen)) {
			openMenu();
		}
		const activeSublists = headerEl.querySelectorAll('.js-nav-sublist.is-active');
		let maxHeight = 0;
		activeSublists.forEach(sublist => {
			const sublistHeight = sublist.clientHeight;
			maxHeight = Math.max(maxHeight, sublistHeight);
		});
		menuBgEl.style.height = isDesktop() ? `${maxHeight}px` : 0;
		parentNavEl && parentNavEl.classList.add(CLASSES.childOpen);
	});
	backBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		subNavEl.classList.remove(CLASSES.active);
		parentEl.classList.remove(CLASSES.active);
		parentNavEl && parentNavEl.classList.remove(CLASSES.childOpen);
	});

};
export const initHeader = () => {
	const headerEl = document.querySelector('.js-header');
	if (!headerEl) return;
	const {documentElement, body} = window.document;
	const burgerEl = headerEl.querySelector('.js-burger');
	const overlayEl = headerEl.querySelector('.js-overlay');
	const subLists = headerEl.querySelectorAll('.js-nav-sublist');
	const subNavParents = headerEl.querySelectorAll('.js-nav-parent > .js-nav-sublist');
	const menuBgEl = headerEl.querySelector('.js-menu-bg');

	headerEl.addEventListener('mouseover', () => {
		if (isDesktop()) {
			headerEl.classList.add(CLASSES.hovered);
		}
	});
	headerEl.addEventListener('mouseout', () => {
		if (isDesktop() && !headerEl.classList.contains(CLASSES.menuOpen)) {
			headerEl.classList.remove(CLASSES.hovered);
		}
	});

	const openMenu = () => {
		scrollTop = window.scrollY;
		burgerEl.classList.add(CLASSES.active);
		headerEl.classList.add(CLASSES.menuOpen);
		headerEl.classList.add(CLASSES.hovered);
		documentElement.classList.add(CLASSES.blocked);
		body.scrollTo(0, scrollTop);
	};
	const closeMenu = () => {
		burgerEl.classList.remove(CLASSES.active);
		headerEl.classList.remove(CLASSES.menuOpen);
		documentElement.classList.remove(CLASSES.blocked);
		subLists.forEach((sublist) => {
			const parentEl = sublist.closest('.js-nav-parent');
			sublist.classList.remove(CLASSES.active);
			parentEl.classList.remove(CLASSES.active);
		});
		window.scrollTo(0, scrollTop);
		menuBgEl.style.height = 0;
		if (!isDesktop()) {
			headerEl.classList.remove(CLASSES.hovered);
		}
	};

	burgerEl.addEventListener('click', () => {
		if (burgerEl.classList.contains(CLASSES.active)) {
			closeMenu();
		}
		else {
			openMenu();
		}
	});

	overlayEl.addEventListener('click', () => {
		closeMenu();
	});

	subNavParents.forEach((item) => createSubNav(item, headerEl, openMenu, closeMenu, menuBgEl));
};
